{
  "name": "@qima/food-certification-service-frontend",
  "version": "1.76.0",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration=development",
    "start:pp": "ng serve --configuration=preprod",
    "start:stg": "ng serve --configuration=staging",
    "start:prod": "ng serve --configuration=production",
    "build": "ng build",
    "build:food-certification-app": "ng build --configuration=production",
    "build:dev": "ng build --configuration=development",
    "build:staging": "ng build --configuration=staging",
    "build:preprod": "ng build --configuration=preprod",
    "build:production": "ng build --configuration=production",
    "create-release": "semantic-release",
    "after-release": "node tools/after-release.js",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "COLLECT_COVERAGE=false ng test --max-workers=4 --watch=false",
    "test:ci:coverage": "COLLECT_COVERAGE=true ng test --max-workers=4 --coverage --watch=false",
    "test:watch": "ng test --watch",
    "test:coverage": "ng test --coverage",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "lint:style": "stylelint \"src/**/*.{css,scss}\"",
    "lint:style:fix": "stylelint \"src/**/*.{css,scss}\" --fix",
    "lint:all:style:ci": "npm run lint:style",
    "format": "prettier --write \"src/**/*.{ts,html,scss,css,json,md}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss,css,json,md}\"",
    "fix:all": "npm run lint:fix && npm run lint:style:fix && npm run format",
    "fix:lint": "npm run lint:fix",
    "fix:style": "npm run lint:style:fix",
    "fix:format": "npm run format",
    "check:all": "npm run lint && npm run lint:style && npm run format:check",
    "check:lint": "npm run lint",
    "check:style": "npm run lint:style",
    "check:format": "npm run format:check",
    "validate:all": "npm run check:all && npm run build",
    "auto-fix": "npm run fix:all",
    "quick-fix": "npm run lint:fix && npm run lint:style:fix",
    "commitlint": "commitlint --edit",
    "aws-sso-login": "aws sso login --profile qima-prod",
    "artifact-registry-login": "aws codeartifact login --tool npm --domain qima --profile qima-prod --region ap-southeast-1 --namespace @qima --repository qima-npm",
    "prepare": "husky"
  },
  "dependencies": {
    "@angular/animations": "^21.0.0",
    "@angular/cdk": "^21.0.0",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-browser-dynamic": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@angular/service-worker": "^21.2.17",
    "@azure/msal-angular": "^2.5.13",
    "@azure/msal-browser": "^2.5.13",
    "@ngneat/reactive-forms": "^5.0.2",
    "@ngneat/until-destroy": "^9.2.3",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@qima/ngx-qima": "21.0.7",
    "@qima/qsp-ui-library": "1.0.35",
    "@types/lodash": "^4.17.20",
    "angular-svg-icon": "^19.0.0",
    "autolinker": "^4.1.5",
    "clipboard": "^2.0.11",
    "country-flags-svg": "^1.1.9",
    "dayjs": "^1.11.9",
    "http-status-codes": "2.3.0",
    "lodash": "^4.17.21",
    "logrocket": "^3.0.1",
    "rxjs": "~7.8.0",
    "ts-md5": "^2.0.1",
    "tslib": "^2.8.0",
    "uuid": "^10.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^21.0.0",
    "@angular-devkit/build-angular": "^21.0.0",
    "@angular-eslint/builder": "21.2.0",
    "@angular-eslint/eslint-plugin": "21.2.0",
    "@angular-eslint/eslint-plugin-template": "21.2.0",
    "@angular-eslint/schematics": "21.2.0",
    "@angular-eslint/template-parser": "21.2.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.0",
    "@commitlint/cli": "^20.1.0",
    "@commitlint/config-conventional": "^20.0.0",
    "@eslint/eslintrc": "2.1.4",
    "@eslint/js": "9.39.2",
    "@jest/test-sequencer": "^30.2.0",
    "@ngneat/spectator": "^20.0.0",
    "@rxlint/eslint-plugin-angular": "^1.2.13",
    "@semantic-release/changelog": "6.0.3",
    "@semantic-release/exec": "6.0.3",
    "@semantic-release/git": "10.0.1",
    "@semantic-release/github": "9.2.6",
    "@semantic-release/npm": "10.0.6",
    "@smarttools/eslint-plugin-rxjs": "1.0.22",
    "@sonia-corporation/conventional-changelog": "1.3.0",
    "@types/jest": "^30.0.0",
    "@types/node": "^24.0.0",
    "@typescript-eslint/eslint-plugin": "8.55.0",
    "@typescript-eslint/parser": "8.55.0",
    "eslint": "9.39.2",
    "eslint-config-prettier": "10.1.8",
    "eslint-import-resolver-typescript": "3.6.1",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "50.8.0",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "eslint-plugin-prettier": "5.5.5",
    "eslint-plugin-progress": "0.0.1",
    "globals": "16.0.0",
    "husky": "^9.1.7",
    "jest": "^30.0.0",
    "jest-environment-jsdom": "^30.0.0",
    "jest-preset-angular": "^16.0.0",
    "lint-staged": "^16.1.2",
    "prettier": "^3.6.2",
    "semantic-release": "20.1.3",
    "stylelint": "^16.22.0",
    "stylelint-config-prettier-scss": "^1.0.0",
    "stylelint-config-standard-scss": "^15.0.1",
    "stylelint-order": "^7.0.0",
    "stylelint-prettier": "^5.0.3",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.55.0"
  },
  "volta": {
    "node": "24.14.1",
    "npm": "11.0.0"
  }
}
